import {Coupon} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';

export const getCouponPromotionId = (coupon?: Coupon | null) => {
  /**
   * When de-selecting a coupon, we set the activatedCoupon to `null` explicitly,
   * thus when calling this function, it should return `null` instead of `undefined`.
   * This is important down the line when we check if the coupon was actively de-selected or not
   */
  if (coupon === null) {
    return null;
  }
  if (!coupon?.type) {
    return undefined;
  }

  switch (coupon.type.$case) {
    case 'simpleCoupon':
      return coupon.type.simpleCoupon.couponPromotionId;
    case 'hotDealCoupon':
      return coupon.type.hotDealCoupon.couponPromotionId;
    case 'minimumOrderValueCoupon':
      return coupon.type.minimumOrderValueCoupon.couponPromotionId;
    case 'highTierCoupon':
      return coupon.type.highTierCoupon.couponPromotionId;
    default:
      return undefined;
  }
};
